import { makeAuthenticatedRequest } from '../utils/api';

export const loginUser = async () => {
	try {
		const url = '/api/auth/login';
		const options = {
			method: 'POST',
		};

		const response = await makeAuthenticatedRequest(url, options);

		return response;
	} catch (error) {
		let errorMessage = 'Unknown error';
		if (error instanceof Error) {
			errorMessage = error.message;
		} else if (error && typeof error === 'object') {
			if ('message' in error) {
				errorMessage = error.message;
			} else {
				errorMessage = JSON.stringify(error);
			}
		} else if (typeof error === 'string') {
			errorMessage = error;
		} else if (error !== null && error !== undefined) {
			errorMessage = String(error);
		} else if (error === null) {
			errorMessage = 'null';
		} else {
			errorMessage = 'undefined';
		}
		const wrappedError = new Error(`Failed to authenticate user: ${errorMessage}`);
		if (error && typeof error === 'object') {
			if ('status' in error) {
				wrappedError.status = error.status;
			}
			if ('type' in error) {
				wrappedError.type = error.type;
			}
		}
		throw wrappedError;
	}
};

export const testHello = async () => {
	try {
		const BACKEND_API_URL = process.env.REACT_APP_BACKEND_API_URL || 'http://localhost:8080';
		const response = await fetch(`${BACKEND_API_URL}/api/hello`, { credentials: 'include' });
		if (!response.ok) {
			const errorData = await response.json().catch(() => ({}));
			const errorMessage = errorData.message || `HTTP error! status: ${response.status}`;
			throw new Error(errorMessage);
		}
		const data = await response.json();
		return data.message || JSON.stringify(data);
	} catch (error) {
		throw new Error(`Failed to call hello endpoint: ${error.message}`);
	}
};

export const testDatabase = async () => {
	const response = await makeAuthenticatedRequest('/api/protected/db-test', { method: 'GET' });
	return response.message || JSON.stringify(response);
};

export const testProtected = async () => {
	const response = await makeAuthenticatedRequest('/api/protected/test-user-info', {
		method: 'GET',
	});
	return response.message || JSON.stringify(response);
};
